import { wait, waitForStableElementPosition } from '../../helpers'
import { DEMO_SCROLL_SPEED } from '../../playback-constants'

export const scrollToDemoRoute = async ({ action, isCancelled }: DemoPlayerActionParams) => {
  const modal = action.closest<HTMLElement>('.demo-player__modal-layer .MuiDialog-paper')

  if (!modal) {
    return false
  }

  const containers: HTMLElement[] = []
  let parent = action.parentElement

  while (parent && modal.contains(parent)) {
    const canScroll = /auto|scroll/.test(getComputedStyle(parent).overflowY)

    if (canScroll && parent.scrollHeight > parent.clientHeight) {
      containers.unshift(parent)
      parent.scrollTo({ top: 0, behavior: 'auto' })
    }

    parent = parent.parentElement
  }

  if (!await waitForStableElementPosition(action, isCancelled)) {
    return false
  }

  await wait(500)

  for (const container of containers) {
    const bounds = container.getBoundingClientRect()
    const target = action.getBoundingClientRect()
    const scale = bounds.height / container.clientHeight || 1
    const offset = (target.top - bounds.top - (bounds.height - target.height) / 2) / scale
    const destination = Math.max(0, Math.min(offset, container.scrollHeight - container.clientHeight))
    const duration = Math.max(500, Math.min(2500, destination / .7)) / DEMO_SCROLL_SPEED
    const frames = Math.ceil(duration / 16)

    for (let frame = 1; frame <= frames; frame += 1) {
      await wait(16)

      if (isCancelled() || !action.isConnected) {
        return false
      }

      const progress = frame / frames
      const easedProgress = progress * progress * (3 - 2 * progress)
      container.scrollTo({ top: destination * easedProgress, behavior: 'auto' })
    }
  }

  return waitForStableElementPosition(action, isCancelled)
}
